import { useLayoutEffect, memo } from 'react';

const APP_NAME = 'Concave Agri - OPS App';

interface ITitle {
  title: string;
}

function Title({ title }: ITitle) {
  useLayoutEffect(() => {
    document.title = title + ' | ' + APP_NAME;

    return () => {
      document.title = APP_NAME;
    };
  }, []);

  return null;
}

export const DocumentTitle = memo(Title);
